import styled from "styled-components";

export const FormPlanRegisterPage = styled.div`
    width: 100%;
    max-width: 1280px;
    padding: 0 15%;
    box-shadow: 0px 0px 10px #88888830;
    background-color: #fff;

    .topFormPage {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    h3 {
        text-align: center;
    }

    h4 {
        text-align: center;
    }

    form {
        width: 820px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
    }

    .inputsContainer {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-end;
        gap: 16px 2%;
        margin-top: 12px;
        padding-top: 8px;
        box-sizing: border-box;
    }

    .inputs {
        width: 400px;
    }

    .smallInput {
        min-width: 260px;
    }

    .checkboxListContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .implementationsBlock {
        width: 100%;
    }

    .checkboxesList {
        width: 100%;
        flex-direction: column;
        flex-wrap: wrap;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .planActiveContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
    }

    .planActiveContainer h4 {
        margin: 5px;
    }

    .buttonsContainer {
        margin-top: 20px;
        margin-bottom: 28px;
        display: flex;
        gap: 3%;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    }

    .serverFeeActions {
        margin-top: 16px;
        margin-bottom: 32px;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    }

    .serverFeeRow {
        margin-bottom: 8px;
    }

    .serverFeeRow .MuiButton-root {
        margin-bottom: 4px;
    }
    @media (max-width: 1050px) {
        form {
            width: 100%;
        }
        .smallInput {
            width: 400px;
        }
        @media (max-width: 700px) {
            .inputs {
                width: 330px;
            }
            .smallInput {
                width: 330px;
            }

            @media (max-width: 400px) {
                h3 {
                    text-align: center;
                }

                .checkboxesList {
                    max-height: 100%;
                }

                .inputs {
                    width: 260px;
                }

                .smallInput {
                    width: 230px;
                }
            }
        }
    }
`;
